module.exports = __webpack_public_path__ + "img/sand-sprint.85653022.jpg";